import { Button } from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';
import React from 'react';
import '../css/App.css';
import '../css/media-query-styles.css';

export const PrintButton: React.FC = () => {
  return (
    <Button onClick={() => window.print()} title="Stampa" variant="contained" color="primary" className={['no-print', 'printBtn'].join(' ')}>
      <PrintIcon />
    </Button>
  );
}

export default PrintButton;